import { useState } from "react";
import { homepageVideos } from "../../data/parasHomeData";

const getVideoId = (video) => {
  if (video.youtubeId) return video.youtubeId;
  if (!video.youtubeUrl) return "";

  const patterns = [
    /youtube\.com\/embed\/([^?&/]+)/,
    /youtube\.com\/shorts\/([^?&/]+)/,
    /youtube\.com\/watch\?v=([^?&/]+)/,
    /youtu\.be\/([^?&/]+)/
  ];

  const match = patterns.map((pattern) => video.youtubeUrl.match(pattern)).find(Boolean);
  return match ? match[1] : "";
};

const getThumbnailUrl = (video, videoId) => (
  video.thumbnail || (videoId ? `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg` : "")
);

function VideoCard({ video }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = getVideoId(video);
  const thumbnailUrl = getThumbnailUrl(video, videoId);
  const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1&cc_load_policy=1&cc_lang_pref=en&hl=en`;

  return (
    <article className="video-card">
      <div className="video-frame">
        {isPlaying && videoId ? (
          <iframe
            src={embedUrl}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : (
          <button
            className="video-thumb"
            type="button"
            aria-label={videoId ? `Play: ${video.title}` : "Video coming soon"}
            disabled={!videoId}
            onClick={() => setIsPlaying(true)}
          >
            {thumbnailUrl ? (
              <img src={thumbnailUrl} alt="" loading="lazy" />
            ) : (
              <span className="video-thumb-fallback" aria-hidden="true">Video</span>
            )}
            <span className="video-overlay">
              <span className="play-btn" aria-hidden="true">Play</span>
              <span className="video-label">{video.label}</span>
            </span>
          </button>
        )}
      </div>
      <div className="video-info">
        <div className="video-title">{video.title}</div>
        <div className="video-sub">{video.sub}</div>
      </div>
    </article>
  );
}

export default function VideosSection() {
  if (!homepageVideos.length) return null;

  return (
    <section className="section alt" id="videos" aria-label="Product videos">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">Watch & Learn</span>
          <h2 className="section-title">See Paras Organics in Action</h2>
          <p className="section-desc">Real results, real gardens - watch how our products transform plant health and yield.</p>
        </div>
        <div className="videos-grid">
          {homepageVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}
